import { isHTMLElement } from "@microsoft/fast-web-utilities";
import { StartEndOptions } from "../start-end/start-end";
import { NatGenOption } from "./option";

/**
 * Option configuration options
 * @public
 */
export type OptionOptions = StartEndOptions<NatGenOption>;

/**
 * Determines if the element is a {@link (NatGenOption:class)}
 *
 * @param element - the element to test.
 * @public
 */
export function isListboxOption(el: Element): el is NatGenOption {
    return (
        isHTMLElement(el) &&
        ((el.getAttribute("role") as string) === "option" ||
            el instanceof HTMLOptionElement)
    );
}
